import React from 'react';
import ClockIcon from '../assets/img/clockicon.png';
import '../assets/css/time-left-timer.css';

const TimeLeftTimer = (props)=> {
    return (
      <div className="time-left-timer fnt-smi-bld d-flex justify-content-between">
        <span className="timer">
          <img src={ClockIcon}  alt="" className="mr-1"/>
          <span>{props.day}{ (props.day>1)?" days":" day"} {props.hour} { (props.hour>1)?" hrs":" hr"} {props.minute} { (props.minute>1)?" mins":" min"}</span>
        </span>
        <span className="timer-text" style={{color:"#344054"}}>left to complete this form</span>
      </div>
    );
}
export default TimeLeftTimer;